import { z } from 'zod';

export function getAccountValidationForBackgroundCheckSchema(
    { requiredInfoText, invalidAddressLine1, invalidPostalCode } = {
        requiredInfoText: 'Required Info',
        invalidAddressLine1: 'Address Line 1 should contain house number and street name separated by space',
        invalidPostalCode: 'Invalid Postal Code',
    },
) {
    return z.object({
        firstName: z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText }),
        lastName: z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText }),
        ssn: z.string().optional(),
        dateOfBirth: z
            .string({ required_error: requiredInfoText })
            .trim()
            .min(1, { message: requiredInfoText })
            .pipe(z.coerce.date({ required_error: requiredInfoText })),
        email: z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText }).email(),
        stateOfWork: z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText }),
        address: z
            .object(
                {
                    addressLine1: z
                        .string({ required_error: requiredInfoText })
                        .trim()
                        .min(1, { message: requiredInfoText })
                        .regex(/\s/, { message: invalidAddressLine1 }),
                    city: z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText }),
                    state: z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText }),
                    postalCode: z
                        .string({ required_error: requiredInfoText })
                        .trim()
                        .min(1, { message: requiredInfoText })
                        .regex(/^[0-9]{5}(?:-[0-9]{4})?$/, { message: invalidPostalCode }),
                },
                { message: requiredInfoText },
            )
            .default({ addressLine1: '', city: '', postalCode: '', state: '' }),
    });
}
